import React from "react";
import { Trash2 } from "lucide-react";

export const Logo = ({ light = false, className = "" }) => {
  return (
    <a
      href="#home"
      data-testid="site-logo"
      className={`flex items-center gap-2.5 group ${className}`}
    >
      <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#2563EB] text-white shadow-sm transition-transform group-hover:scale-105">
        <Trash2 className="h-5 w-5" strokeWidth={2.2} />
      </span>
      <span className="leading-tight">
        <span
          className={`block font-display text-lg font-extrabold tracking-tight ${
            light ? "text-white" : "text-[#1E293B]"
          }`}
        >
          Coastal Valet Trash
        </span>
        <span
          className={`block text-[11px] font-medium tracking-[0.18em] uppercase ${
            light ? "text-blue-200" : "text-[#2563EB]"
          }`}
        >
          Savannah, Georgia
        </span>
      </span>
    </a>
  );
};
